import { render, staticRenderFns } from "./GeneralJournal.vue?vue&type=template&id=81add692&scoped=true"
import script from "./GeneralJournal.vue?vue&type=script&lang=js"
export * from "./GeneralJournal.vue?vue&type=script&lang=js"
import style0 from "./GeneralJournal.vue?vue&type=style&index=0&id=81add692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81add692",
  null
  
)

export default component.exports